import { type ComponentProps, memo } from 'react';

import { InfinityIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

export const CREDIT_USAGE_OVERAGE_LABEL = 'Credits are currently unlimited for AI actions';

export type CreditUsageOverageLabelProps = Pick<ComponentProps<'p'>, 'className'> & {
  allowCreditOverage: boolean;
};

export const CreditUsageOverageLabel = memo(({ allowCreditOverage, className }: CreditUsageOverageLabelProps) => {
  if (!allowCreditOverage) {
    return null;
  }

  return (
    <p
      className={cn('flex items-center gap-1 ads:text-metadata text-12 text-gray-9', className)}
      data-testid="CREDIT_USAGE_OVERAGE_LABEL"
    >
      <InfinityIcon aria-hidden className="size-3 shrink-0" />
      {CREDIT_USAGE_OVERAGE_LABEL}
    </p>
  );
});

CreditUsageOverageLabel.displayName = 'CreditUsageOverageLabel';
